import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiIconButton: {
  defaultProps?: ComponentsProps['MuiIconButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiIconButton'];
  variants?: ComponentsVariants['MuiIconButton'];
} = {
  styleOverrides: {
    root: {
      padding: '12px',
    },
    sizeSmall: {
      padding: '3px',
      fontSize: '1.125rem',
    },
  },
};

export default muiIconButton;
